<template>
  <div class="meetingplan-application">
    <div class="page-contain">
      <div class="application-search-content-main">
          <el-form class="application-search-content-main-fields" :inline="true">
              <el-form-item class="application-search-content-main-fields-year">
                  <el-select placeholder="请选择" v-model="searchMainData.year" @change="handleMainSearch()">
                    <el-option class="application-search-content-main-fields-year-items" v-for="item in baseDataRecords.Year" :key="item.id" :value="item.id" :label="item.yearName">
                    </el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-for="(quarter, index) in searchMainQuarters" :key="index" :class="[searchMainData.quarter == quarter?'active':'', 'application-search-content-main-fields-quarter']">
                  <label @click="handleMainSearch(quarter)">{{quarter}}</label>
              </el-form-item>
              <el-form-item class="application-search-content-main-add">
                  <el-button :disabled="!canCreateMeeting" type="primary" plain @click="handleAddClick">+ 添加会议</el-button>
              </el-form-item>
          </el-form>
          <div class="application-search-content-main-fields-quarter-lines">
            <div v-for="(quarter, index) in searchMainQuarters" :key="index" :class="[searchMainData.quarter == quarter?'line-active':'', 'application-search-content-main-fields-quarter-lines-line','application-search-content-main-fields-quarter-lines-line-q'+(index+1)]"></div>
          </div>
      </div>
      <div class="page-contain-main-tab">
        <div class="main-blocks">
          <div class="main-block">
            <div class="main-block-contain">
              <div class="main-block-contain-title">{{mainData['1'].statusName}}<common-tooltip tipCode="5"></common-tooltip></div>
              <div class="main-block-contain-application">
                <i class="iconfont icon-yitijiao"></i>
                <label>￥{{mainData['1'].totalAmountStr}}</label>
              </div>
              <div class="main-block-contain-split-line"></div>
              <div class="main-block-contain-total">数量<label>{{mainData['1'].count}}</label></div>
            </div>
          </div>
          <div class="main-block">
            <div class="main-block-contain">
              <div class="main-block-contain-title">{{mainData['2'].statusName}}<common-tooltip tipCode="6"></common-tooltip></div>
              <div class="main-block-contain-application">
                <i class="iconfont icon-shenpizhong"></i>
                <label>￥{{mainData['2'].totalAmountStr}}</label>
              </div>
              <div class="main-block-contain-split-line"></div>
              <div class="main-block-contain-total">数量<label>{{mainData['2'].count}}</label></div>
            </div>
          </div>
          <div class="main-block">
            <div class="main-block-contain">
              <div class="main-block-contain-title">{{mainData['4'].statusName}}<common-tooltip tipCode="2.1"></common-tooltip></div>
              <div class="main-block-contain-application">
                <i class="iconfont icon-shenpitongguo"></i>
                <label>￥{{mainData['4'].totalAmountStr}}</label>
              </div>
              <div class="main-block-contain-split-line"></div>
              <div class="main-block-contain-total">数量<label>{{mainData['4'].count}}</label></div>
            </div>
          </div>
          <div class="main-block">
            <div class="main-block-contain">
              <div class="main-block-contain-title">{{mainData['5'].statusName}}<common-tooltip tipCode="4.1"></common-tooltip></div>
              <div class="main-block-contain-application">
                <i class="iconfont icon-shenpijujue"></i>
                <label>￥{{mainData['5'].totalAmountStr}}</label>
              </div>
              <div class="main-block-contain-split-line"></div>
              <div class="main-block-contain-total">数量<label>{{mainData['5'].count}}</label></div>
            </div>
          </div>
        </div>
      </div>
      <div class="page-contain-tab">
        <div class="content-box">
          <div class="search-content">
              <el-form class="search-content-fields" :inline="true">
                <el-form-item label="申请状态">
                    <el-select multiple clearable v-model="searchData.status">
                        <el-option v-for="item in baseDataRecords.MyApplicationStatus" :key="item.value" :value="item.value" :label="item.text">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Franchise/DA">
                    <el-select @change="searchData.teamL4 = ''" clearable v-model="searchData.medicalField">
                        <el-option v-for="item in getMedicalFieldArray(searchData.departId, true)" :key="item.id" :value="item.id" :label="item.medicalFieldName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="团队">
                    <el-select clearable placeholder="请选择" v-model="searchData.teamL4">
                        <el-option v-for="item in getTeamArray(searchData.departId, searchData.medicalField, true)" :key="item.id" :value="item.id" :label="item.teamName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="search-content-fields-operate">
                    <el-button type="primary" @click="handleSearch()">查询</el-button>
                    <el-button type="primary" plain @click="handleAdvancedSearchClick()">高级查询</el-button>
                    <el-button plain @click="handleResetSearchCondition()">重置</el-button>
                </el-form-item>
              </el-form>
          </div>
          <div class="toolbar">
            <div class="application-detail-info">共计&nbsp;{{applicationDetailCount}}&nbsp;场&nbsp;预算总额：{{applicationDetailAmt | MoneyFormat}}&nbsp;当前排队提交中：{{inQueueNumber}}场</div>
            <div class="operate">
              <div class="operate-export">
                <a href="javascript:void(0)" @click="handlerExportExcelClick">
                  <i class="iconfont icon-daochu"></i>
                  <span>导出</span>
                </a>
              </div>
            </div>
          </div>
          <common-crud ref="crud"
            :searchData="searchData"
            :searchDataLikeField="{'productId':'*','companyStrategy':'*','strategyKeynote':'*','medicalFieldResult':'*','hospitalLevelId':'*','speakerLevelId':'*'}"
            :crudApi="crudApi"
            :tableData.sync="applicationDetailData"
            :showEditFormTitle="false"
            editDialogClass="biz-application-detail-edit-dialog"
            :handleSearchResult="handleSearchResult"
            :selectedDataArray.sync="selectedData"
            :afterDelete="handleApplicationDeleted"
            deleteSuccessMessages="删除会议成功"
          >
            <template slot="result">
              <el-table-column type="selection" width="55">
              </el-table-column>
              <el-table-column type="index" :index="indexMethod" width="60" label="序号">
              </el-table-column>
              <el-table-column sortable prop="meetingName" label="会议名称" width="200">
              </el-table-column>
              <el-table-column sortable prop="teamL4" label="团队" width="130">
              </el-table-column>
              <el-table-column :formatter="formatBaseData" sortable prop="productId" label="产品" width="130">
              </el-table-column>
              <el-table-column :formatter="formatBaseData" sortable prop="meetingSystem" label="系统选择" width="130">
              </el-table-column>
              <el-table-column :formatter="formatBaseData" sortable prop="meetingProp" label="会议性质" width="120">
              </el-table-column>
              <el-table-column :formatter="formatBaseData" sortable prop="meetingType" label="A1会议类型" width="120">
              </el-table-column>
              <el-table-column :formatter="formatBaseData" sortable prop="meetingGsdType" label="GSD项目类型" width="140">
              </el-table-column>
              <el-table-column sortable prop="meetingGsdType" label="GSD细类" width="120">
                <template slot-scope="scope">
                    <div>
                        {{basedataGetName('MeetingGsdTypeSub'+scope.row.meetingGsdType, scope.row.meetingGsdSubType)}}
                    </div>
                </template>
              </el-table-column>
              <el-table-column sortable prop="totalAmount" label="会议总预算" width="140">
                <template slot-scope="scope">
                    <div>                    
                        {{scope.row.totalAmount | MoneyFormat}}
                    </div>
                </template>
              </el-table-column>
              <el-table-column sortable prop="queueTaskStatus" label="排队状态" width="140" >
                <template slot-scope="scope">
                    <div :style="{'color':scope.row.queueTaskStatus=='失败'? 'red':'#2d82f0'}">
                        {{scope.row.queueTaskStatus}}
                    </div>
                </template>
              </el-table-column>
              <el-table-column sortable prop="modelScore" width="140">
                <span class="tooltip-header-text" slot="header">模型评分<common-tooltip tipCode="8"></common-tooltip></span>
              </el-table-column>
              <el-table-column :formatter="formatDateTime2Date" sortable prop="meetingBeginDate" label="开始日期" width="120">
              </el-table-column>
              <el-table-column sortable prop="cityName" label="城市">
              </el-table-column>
              <el-table-column sortable prop="meetingWebStatus" label="会议计划状态" width="150">
              </el-table-column>
              <el-table-column sortable prop="meetingCurrentOptName" label="会议计划审批结点" width="180">
              </el-table-column>
              <el-table-column sortable prop="aoneExeStatus" label="会议执行状态" width="160">
              </el-table-column>
              <el-table-column sortable prop="userRealName" label="会议组织者" width="140">
              </el-table-column>
              <el-table-column sortable prop="meetingCode" label="计划编号" width="140">
              </el-table-column>
              <el-table-column prop="eventId" label="A1会议编号" width="140">
              </el-table-column>
              <el-table-column sortable prop="createTime" label="创建时间" width="140" >
                <template slot-scope="scope">
                    <div>
                        {{scope.row.createTime | DateHourMinutesFormat}}
                    </div>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="160">
                <template slot-scope="scope">
                  <div class="table-column-operate">
                    <div v-if="scope.row.meetingWebStatus == '待提交'">
                      <el-button type="text" @click="handleEditClick(scope.row)">
                        编辑
                      </el-button>
                      <el-button type="text" @click="handleCopyClick(scope.row)">
                        复制
                      </el-button>
                      <el-button type="text" @click="handleDeleteClick(scope.row)">
                        删除
                      </el-button>
                    </div>
                    <div v-if="scope.row.meetingWebStatus != '待提交'">
                      <el-button type="text" @click="handleViewClick(scope.row)">
                        查看
                      </el-button>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </template>
            <template slot="confirmDeleteMessage">
              <div>
                <span>确认删除会议？</span>
              </div>
            </template>
          </common-crud>
        </div>
      </div>
    </div>
    <div class="bottom-info">
      <div class="bottom-info-info">已选择&nbsp;{{selectedData.length}}&nbsp;场会议&nbsp;预算总额：<label>{{selectedTotalAmount | MoneyFormat}}</label></div>
      <div class="bottom-info-operate">
        <el-button :disabled="!canBatchSubmit" type="primary" @click="handleBatchSubmit">提交</el-button>
      </div>
    </div>
    <!-- 高级查询 -->
    <div>
      <el-dialog class="advanced-search-dialog" center :visible.sync="advancedSearchVisible" :close-on-click-modal="false">
          <el-form :model="searchData" ref="advancedSearchForm" label-position="right" label-width="100px">
              <el-row>
                <div class="advanced-search-form-title">
                  <i :class="'iconfont icon-huiyizhuangtai'" class="l-user-item-icon"></i>
                  <span class="l-user-item-text">会议状态</span>
                </div>
                <el-col>
                    <el-form-item label="申请状态" prop="status">
                        <el-select multiple clearable placeholder="请选择" v-model="searchData.status">
                            <el-option v-for="item in baseDataRecords.MyApplicationStatus" :key="item.value" :value="item.value" :label="item.text">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col>
                    <el-form-item label="会议执行状态" prop="aoneExeStatus">
                        <el-select clearable placeholder="请选择" v-model="searchData.aoneExeStatus">
                            <el-option v-for="item in baseDataRecords.AoneExeStatus" :key="item.value" :value="item.value" :label="item.text">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col>
                    <el-form-item label="排队状态" prop="queueTaskStatus">
                        <el-select clearable placeholder="请选择" v-model="searchData.queueTaskStatus">
                            <el-option v-for="item in baseDataRecords.QueueTaskStatus.filter(q => q.value != '1')" :key="item.value" :value="item.value" :label="item.text">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <div class="advanced-search-form-title">
                  <i :class="'iconfont icon-jibinglingyu'" class="l-user-item-icon"></i>
                  <span class="l-user-item-text">疾病领域</span>
                </div>
                <el-col>
                    <el-form-item label="部门" prop="departId">
                        <el-select @change="searchData.medicalField = '';searchData.teamL4 = ''" clearable placeholder="请选择" v-model="searchData.departId">
                            <el-option v-for="item in baseDataRecords.Depart" :key="item.id" :value="item.id" :label="item.departName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col>
                    <el-form-item label="Franchise/DA" prop="medicalField">
                        <el-select @change="searchData.teamL4 = ''" clearable placeholder="请选择" v-model="searchData.medicalField">
                            <el-option v-for="item in getMedicalFieldArray(searchData.departId, true)" :key="item.id" :value="item.id" :label="item.medicalFieldName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col>
                    <el-form-item label="团队" prop="teamL4">
                        <el-select clearable placeholder="请选择" v-model="searchData.teamL4">
                            <el-option v-for="item in getTeamArray(searchData.departId, searchData.medicalField, true)" :key="item.id" :value="item.id" :label="item.teamName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <div class="advanced-search-form-title">
                </div>
                <el-col>
                    <el-form-item label="治疗领域" prop="treatmentArea">
                        <el-select filterable clearable placeholder="请选择（可搜索）" v-model="searchData.treatmentArea">
                            <el-option v-for="item in baseDataRecords.TreatmentArea" :key="item.id" :value="item.id" :label="item.treatmentAreaName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col>
                    <el-form-item label="疾病领域" prop="diseaseArea">
                        <el-select filterable clearable placeholder="请选择（可搜索）" v-model="searchData.diseaseArea">
                            <el-option v-for="item in baseDataRecords.DiseaseArea" :key="item.id" :value="item.id" :label="item.diseaseAreaName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col>
                    <el-form-item label="产品" prop="productId">
                        <el-select filterable clearable placeholder="请选择（可搜索）" v-model="searchData.productId">
                            <el-option v-for="item in baseDataRecords.Product" :key="item.id" :value="item.id" :label="item.productName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <div class="advanced-search-form-title">
                  <i :class="'iconfont icon-chanpincelve'" class="l-user-item-icon"></i>
                  <span class="l-user-item-text">产品策略</span>
                </div>
                <el-col>
                    <el-form-item label="公司战略" prop="companyStrategy">
                        <el-select clearable placeholder="请选择" v-model="searchData.companyStrategy">
                            <el-option v-for="item in baseDataRecords.CompanyStrategy" :key="item.value" :value="item.value" :label="item.text">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col>
                    <el-form-item label="策略重点" prop="strategyKeynote">
                        <el-select filterable clearable placeholder="请选择（可搜索）" v-model="searchData.strategyKeynote">
                            <el-option v-for="item in baseDataRecords.Strategy" :key="item.id" :value="item.id" :label="item.keynote">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col>
                    <el-form-item label="业务结果" prop="medicalFieldResult">
                        <el-select filterable clearable placeholder="请选择（可搜索）" v-model="searchData.medicalFieldResult">
                            <el-option v-for="item in baseDataRecords.DomainResult" :key="item.id" :value="item.id" :label="item.treatAreaResult">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <div class="advanced-search-form-title">
                  <i :class="'iconfont icon-fugaiziyuan'" class="l-user-item-icon"></i>
                  <span class="l-user-item-text">覆盖资源</span>
                </div>
                <el-col>
                    <el-form-item label="医院层级" prop="hospitalLevelId">
                        <el-select clearable placeholder="请选择" v-model="searchData.hospitalLevelId">
                            <el-option v-for="item in baseDataRecords.HospitalLevel" :key="item.id" :value="item.id" :label="item.hospitalLevel">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col>
                    <el-form-item label="科室" prop="offices">
                        <el-select filterable clearable placeholder="请选择（可搜索）" v-model="searchData.offices">
                            <el-option v-for="item in baseDataRecords.Office" :key="item.id" :value="item.id" :label="item.officeName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col>
                    <el-form-item label="讲者级别" prop="speakerLevelId">
                        <el-select clearable placeholder="请选择" v-model="searchData.speakerLevelId">
                            <el-option v-for="item in baseDataRecords.SpeakerLevel" :key="item.id" :value="item.id" :label="item.speakerLevel">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <div class="advanced-search-form-title">
                  <i :class="'iconfont icon-pingfenjieguo'" class="l-user-item-icon"></i>
                  <span class="l-user-item-text">评分结果</span>
                </div>
                <el-col>
                    <el-form-item label="模型评分">
                        <div class="advanced-search-dialog-score-model">
                        <el-input-number placeholder="最小评分" :controls="false" :precision="0" :min="1" :max="100" v-model="searchData.minModelScore"></el-input-number>
                        <span></span>
                        <el-input-number placeholder="最大评分" :controls="false" :precision="0" :min="1" :max="100" v-model="searchData.maxModelScore"></el-input-number>
                        </div>
                    </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <div class="advanced-search-form-title">
                  <i :class="'iconfont icon-huiyixinxi'" class="l-user-item-icon"></i>
                  <span class="l-user-item-text">会议信息</span>
                </div>
                <el-col>
                    <el-form-item label="系统选择" prop="meetingSystem">
                        <el-select multiple clearable placeholder="请选择" v-model="searchData.meetingSystem">
                            <el-option v-for="item in baseDataRecords.MeetingSystem" :key="item.value" :value="item.value" :label="item.text">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col>
                    <el-form-item label="会议性质" prop="meetingProp">
                        <el-select clearable placeholder="请选择" v-model="searchData.meetingProp">
                            <el-option v-for="item in baseDataRecords.MeetingProp" :key="item.value" :value="item.value" :label="item.text">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col>
                    <el-form-item label="是否网络会" prop="meetingModality">
                        <el-select clearable placeholder="请选择" v-model="searchData.meetingModality">
                            <el-option v-for="item in baseDataRecords.MeetingModality" :key="item.value" :value="item.value" :label="item.text">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <div class="advanced-search-form-title">
                </div>
                <el-col>
                    <el-form-item label="A1会议类型" prop="meetingType">
                        <el-select clearable placeholder="请选择" v-model="searchData.meetingType">
                            <el-option v-for="item in baseDataRecords.MeetingType" :key="item.value" :value="item.value" :label="item.text">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col>
                    <el-form-item label="GSD项目类型" prop="meetingGsdType">
                        <el-select @change="searchData.meetingGsdSubType = ''" clearable placeholder="请选择" v-model="searchData.meetingGsdType">
                            <el-option v-for="item in baseDataRecords.MeetingGsdType" :key="item.value" :value="item.value" :label="item.text">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col>
                    <el-form-item label="GSD细类" prop="meetingGsdSubType">
                        <el-select clearable placeholder="请选择" v-model="searchData.meetingGsdSubType">
                            <el-option v-for="item in MeetingGsdSubTypes" :key="item.value" :value="item.value" :label="item.text">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <div class="advanced-search-form-title">
                </div>
                <el-col>
                    <el-form-item label="会议名称" prop="meetingName">
                        <el-input v-model="searchData.meetingName" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col>
                    <el-form-item label="计划编号" prop="meetingCode">
                        <el-select @change="remoteMeetingCodeData=[]" filterable remote :remote-method="handleMeetingCodeFilter" clearable placeholder="请输入" v-model="searchData.meetingCode">
                            <el-option v-for="(item,index) in remoteMeetingCodeData" :key="index" :value="item" :label="item">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col>
                    <el-form-item label="A1编号" prop="eventId">
                        <el-input v-model="searchData.eventId" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <div class="advanced-search-form-title">
                </div>
                <el-col>
                    <el-form-item label="会议组织者" prop="userRealName">
                        <el-select @change="remoteMeetingCreatorData=[]" filterable remote :remote-method="handleMeetingCreatorFilter" clearable placeholder="请输入" v-model="searchData.userRealName">
                            <el-option v-for="(item,index) in remoteMeetingCreatorData" :key="index" :value="item.CName" :label="item.CName+' '+item.AD">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col>
                    <el-form-item label="会议申请人" prop="meetingOrganizerId">
                        <el-select @change="remoteMeetingOrganizerData=[]" filterable remote :remote-method="handleMeetingOrganizerFilter" clearable placeholder="请输入" v-model="searchData.meetingOrganizerId">
                            <el-option v-for="(item) in remoteMeetingOrganizerData" :key="item.Id" :value="item.Id" :label="item.CName+' '+item.AD">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col>
                    <el-form-item label="成本中心" prop="costCenter">
                        <el-select filterable @change="handleSearchCostCenterChange" clearable placeholder="请选择（可搜索）" v-model="searchData.costCenter">
                            <el-option v-for="item in costCenterArray" :key="item.costId" :value="item.costId" :label="item.costId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <div class="advanced-search-form-title">
                </div>
                <el-col>
                    <el-form-item label="WBS code" prop="wbsCode">
                        <el-select clearable placeholder="请选择" v-model="searchData.wbsCode">
                            <el-option v-for="item in wbsCodeArray" :key="item.costId" :value="item.costId" :label="item.costId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <div class="advanced-search-form-title">
                  <i :class="'iconfont icon-shijian'" class="l-user-item-icon"></i>
                  <span class="l-user-item-text">时间地点</span>
                </div>
                <el-col>
                    <el-form-item label="起止日期" prop="dateRange">
                        <el-date-picker
                          v-model="searchData.dateRange"
                          type="daterange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col>
                    <el-form-item label="省份" prop="province">
                        <el-select @change="handleProvinceChange" clearable placeholder="请选择" v-model="searchData.province">
                            <el-option v-for="item in baseDataRecords.Province" :key="item.id" :value="item.id" :label="item.name">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col>
                    <el-form-item label="城市" prop="city">
                        <el-select clearable placeholder="请先选择省份" v-model="searchData.city">
                            <el-option v-for="item in citiesData" :key="item.id" :value="item.id" :label="item.name">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <div class="advanced-search-form-title">
                </div>
                <el-col>
                    <el-form-item label="创建日期" prop="createDateRange">
                        <el-date-picker
                          v-model="searchData.createDateRange"
                          type="daterange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
              </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="handleSearch()">高级查询</el-button>
              <el-button plain @click="handleResetSearchCondition()">重置</el-button>
              <label class="advanced-search-dialog-close" @click="advancedSearchVisible = false">关闭</label>
          </div>
      </el-dialog>
    </div>
    <!-- 确认批量提交 -->
    <common-confirm :dialogVisiable.sync="confirmBatchSubmitVisible" :confirm="handlerBatchSubmitConfirmOK">
        <div>
            确认提交 {{selectedData.length}} 场会议申请？
        </div>
        <div v-if="isSeasonlyType">
            该季度的计划申请，需要直线经理和二级审批人审批
        </div>
        <div v-else>
            {{monthlyTypeMessage}}
        </div>
    </common-confirm>
  </div>
</template>

<script>
import costCenterAndWbs from '@/api/costCenterAndWbs';
import application from '@/api/meetingplan/application';
import basedata from '@/api/basedata';
import { mapGetters, mapActions } from 'vuex';
import * as StorageService from '@/util/StorageService';
import * as orgUtil from '@/util/organizationUtil'


export default {
  data() {
    return {
      applicationDetailData :[],
      searchMainData: {
        year: '',
        quarter: 'Q1',
      },
      searchData: {
        status:[],
        queueTaskStatus:'',
        departId: '',
        medicalField: '',
        teamL4: '',
        productId: '',
        city:'',
        dateRange: null,
        createDateRange: null,
        wbsCode: '',
        meetingGsdType: '',
        meetingGsdSubType: '',
      },
      mainData: {
        '1':{},
        '2':{},
        '4':{},
        '5':{},
      },
      crudApi: application,
      isEdit: false,
      applicationDetailCount: 0,
      applicationDetailAmt: 0,
      searchMainQuarters: ['Q1','Q2','Q3','Q4'],
      advancedSearchVisible: false,
      citiesData: [],
      remoteMeetingCodeData: [],
      remoteMeetingCreatorData: [],
      remoteMeetingOrganizerData: [],
      selectedData: [],
      confirmBatchSubmitVisible: false,
      canCreateMeeting: false,
      monthlyTypeMessage: '',
      costCenterArray: [],
      wbsCodeArray: [],
      inQueueNumber: 0
    }
  },
  computed: {
    ...mapGetters(['userInfo','baseDataRecords','basedataGetName','basedataGetNameByRowIdField']),
    MeetingGsdSubTypes() {
        return this.baseDataRecords['MeetingGsdTypeSub'+this.searchData.meetingGsdType] || [];
    },
    canBatchSubmit() {
      for (let index = 0; index < this.selectedData.length; index++) {
        const element = this.selectedData[index];
        if(element.queueTaskStatus === '排队中'){
          return false;
        }else if(element.meetingWebStatus != '待提交'){
          return false;
        }
      }

      return this.selectedData.length > 0;
    },
    selectedTotalAmount() {
      let amount = 0;
      this.selectedData.forEach(data => {
        amount += data.totalAmount;
      })

      return amount;
    },
    isSeasonlyType() {
        if(this.selectedData && this.selectedData.length > 0) {
            return this.selectedData[0].meetingDateType == '1';
        }

        return false;
    },
  },
  methods: {
    ...mapActions(['initBaseDataByTypes']),
    getMedicalFieldArray(departId, independ) {
      return orgUtil.franchiseArray(departId, independ);
    },
    getTeamArray(departId, medicalField, independ) {
      return orgUtil.teamArray(departId, medicalField, independ);
    },
    formatDateTime2Date(row, column, cellValue, index) {
      return this.$refs['crud'].formatDateTime2Date(row, column, cellValue, index);
    },
    formatBaseData(row, column, cellValue, index) {
      if(column.property == 'productId'){
          if(row.productId) {
            let ids = row.productId;
            if(typeof ids == 'string') {
              ids =  ids.split(',');
            }
            let names = []
            for (let pidIndex = 0; pidIndex < ids.length; pidIndex++) {
              names.push(this.basedataGetName('Product', ids[pidIndex]));
            }
            return names.join(',')
          }
          return row.prodIds;
      }
      if(column.property == 'meetingSystem'){
          if(row.meetingSystem) {
            let ids = row.meetingSystem;
            if(typeof ids == 'string') {
              ids =  ids.split(',');
            }
            let names = []
            for (let pidIndex = 0; pidIndex < ids.length; pidIndex++) {
              names.push(this.basedataGetName('MeetingSystem', ids[pidIndex]));
            }
            return names.join(',')
          }
          return row.prodIds;
      }

      return this.basedataGetNameByRowIdField(column.property, row);
    },
    indexMethod(index) {
      return this.$refs['crud'].indexMethod(index);
    },
    handleSearch() {
      //查询时不传dateRange，查询后重新赋值，用于界面查看
      let tempDateRange = this.searchData.dateRange;
      if(this.searchData.dateRange && this.searchData.dateRange.length == 2) {
        this.searchData.meetingBeginDate = moment(this.searchData.dateRange[0]).format('YYYY-MM-DD HH:mm:ss');
        this.searchData.meetingEndDate = moment(this.searchData.dateRange[1]).format('YYYY-MM-DD HH:mm:ss');
        this.searchData.dateRange = null;
      }
      else{
        this.searchData.meetingBeginDate = '';
        this.searchData.meetingEndDate = '';
        this.searchData.dateRange = null
      }
      //查询时不传dateRange，查询后重新赋值，用于界面查看
      let tempCreateDateRange = this.searchData.createDateRange;
      if(this.searchData.createDateRange && this.searchData.createDateRange.length == 2) {
        this.searchData.createBeginDate = moment(this.searchData.createDateRange[0]).format('YYYY-MM-DD HH:mm:ss');
        this.searchData.createEndDate = moment(this.searchData.createDateRange[1]).format('YYYY-MM-DD HH:mm:ss');
        this.searchData.createDateRange = null;
      }
      else{
        this.searchData.createBeginDate = '';
        this.searchData.createEndDate = '';
        this.searchData.createDateRange = null
      }

      this.searchData.year = this.searchMainData.year;
      this.searchData.season = this.searchMainData.season;

      StorageService.setItem(StorageService.keys.MyApplicationSearchDetailData,JSON.stringify(this.searchData));

      let statusAll = false;
      if(this.searchData.status.length == 0) {
        statusAll = true;

        this.searchData.status = this.baseDataRecords.MyApplicationStatus.map(s => s.value)
      }

      this.$refs['crud'].handleSearch(1);
      this.advancedSearchVisible = false;
      this.searchData.dateRange = tempDateRange;
      this.searchData.createDateRange = tempCreateDateRange;
      if(statusAll) {
        this.searchData.status = ''
      }
    },
    handleResetSearchCondition() {
      this.$refs['crud'].resetObject(this.searchData);
      this.searchData.minModelScore = undefined;
      this.searchData.maxModelScore = undefined;
      this.searchData.status = ['1'];
      this.wbsCodeArray = [];
    },
    handleSearchResult(res) {
      this.applicationDetailCount = res.rowCount;
      this.applicationDetailAmt = res.sumTotalAmt;
      this.inQueueNumber = res.watingCount;

      res.current = res.pageList.current;
      res.total = res.pageList.total;

      this.applicationDetailData = res.pageList.records;
    },
    handleViewClick(item) {
      this.$router.push({
        name: 'meetingplan-application-view',
        params: {
          'id':item.id,
          }
      });
    },
    handleEditClick(item) {
      this.$router.push({
        name: 'meetingplan-application-edit',
        params: {
          'id':item.id,
          }
      });
    },
    handleCopyClick(item) {
      this.$router.push({
        name: 'meetingplan-application-copy',
        params: {
          'id':item.id,
          }
      });
    },
    handleAddClick(item) {
      this.$router.push({
        name: 'meetingplan-application-add',
        params: {
          'year':this.searchMainData.year,
          'season':this.searchMainData.quarter.replace('Q','')
          }
      });
    },
    handleDeleteClick(item) {
      this.$refs['crud'].handleDelete(item);
    },
    handleApplicationDeleted() {
      this.handleMainSearch(this.searchMainData.quarter);
    },
    handleMainSearch(quarter) {
      if(quarter) {
        this.searchMainData.quarter = quarter;
        this.searchMainData.season = quarter.replace('Q','');
      }
      StorageService.setItem(StorageService.keys.MyApplicationSearchMainData,JSON.stringify(this.searchMainData));
      application.queryMainApplication(this.searchMainData)
          .then(res => {
            this.mainData = {};
            res.forEach(data => {
              data.statusName = this.basedataGetName('MyApplicationStatus',data.status);
              this.mainData[data.status.toString()] = data;
            });

            this.initCreateMeetingInfo();

            this.handleSearch();
          })
    },
    handleAdvancedSearchClick() {
      this.advancedSearchVisible = true;
    },
    handleProvinceChange() {
      this.searchData.city = ''
      if(this.searchData.province) {
        basedata.listCity({provinceId:this.searchData.province})
                .then(res => {
                  this.citiesData = res.records;
                })
      }
      else {
        this.citiesData = []
      }
    },
    handleMeetingCodeFilter(query) {
      if(!query) {
        this.remoteMeetingCodeData = [];
        return;
      }
      application.filterMeetingCode({
            'code':query,
            year: this.searchMainData.year,
            season: this.searchMainData.season,
          })
          .then(res => {
            this.remoteMeetingCodeData = res;
          })
    },
    handleMeetingCreatorFilter(query) {
      if(!query) {
        this.remoteMeetingCreatorData = [];
        return;
      }
      application.filterMeetingCreator({'name':query})
          .then(res => {
            this.remoteMeetingCreatorData = res;
          })
    },
    handleMeetingOrganizerFilter(query) {
      if(!query) {
        this.remoteMeetingOrganizerData = [];
        return;
      }
      application.filterMeetingOrganizer({'name':query})
          .then(res => {
            this.remoteMeetingOrganizerData = res;
          })
    },
    handleBatchSubmit() {
      if(this.isSeasonlyType) {
          this.confirmBatchSubmitVisible = true;
      }
      else {
          let tempIds = [];
          this.selectedData.forEach(meeting => {
            tempIds.push(meeting.id);
          })
          application.submitMeetingApprove({
                        year: this.searchMainData.year,
                        season: this.searchMainData.season,
                        id: tempIds.join(',')
                      })
                  .then(res => {
                      this.monthlyTypeMessage = res;
                      this.confirmBatchSubmitVisible = true;
                  })
      }
    },
    handlerBatchSubmitConfirmOK() {
      let tempIds = [];
      this.selectedData.forEach(meeting => {
        tempIds.push(meeting.id);
      })

      application.batchSubmit({
        year: this.searchMainData.year,
        season: this.searchMainData.season,
        id: tempIds.join(',')
        }).then(res => {
          this.$message.success(res.resultTxt);
          this.handleSearch();
        })
    },
    initCreateMeetingInfo() {
      application.getCanCreateMeeting({
        year: this.searchMainData.year,
        season: this.searchMainData.season,
      }).then(res => {
        this.canCreateMeeting = res.canCreateMeeting;
      });
    },
    handlerExportExcelClick() {
      this.$refs['crud'].handlerExportExcel('我的申请.xlsx', {meetingFrom: 0});
    },
    handleSearchCostCenterChange() {
      this.searchData.wbsCode = ''
      this.wbsCodeArray = [];

      if(!this.searchData.costCenter) {
          return;
      }

      costCenterAndWbs.listLocalWbsCode(
                    {
                      companyCode: this.userInfo.companyCode,
                      costCenter: this.searchData.costCenter
                    }
                  )
                  .then(res => {
                    this.wbsCodeArray = res;
                  })

    },
  },
  mounted() {
    // this.searchData.queueTaskStatus = '0';
    let searchDetailDataTemp = StorageService.getItem(StorageService.keys.MyApplicationSearchDetailData);
    if(searchDetailDataTemp) {
        this.searchData = JSON.parse(searchDetailDataTemp);
    }
    else{
      this.searchData.status = ['1'];
    }

    let searchMainDataTemp = StorageService.getItem(StorageService.keys.MyApplicationSearchMainData);

    if(searchMainDataTemp) {
        this.searchMainData = JSON.parse(searchMainDataTemp);
    }
    else{
      this.searchMainData.year = (new Date()).getFullYear();
      this.searchMainData.quarter = 'Q'+Math.ceil(((new Date()).getMonth()+1)/3)
    }

    this.initBaseDataByTypes(['Year','MyApplicationStatus','AoneExeStatus','QueueTaskStatus','MeetingType','MeetingProp','MeetingModality','MeetingSystem','Depart','MedicalField','TreatmentArea','DiseaseArea','Product','CompanyStrategy','Strategy','DomainResult','MeetingTimeInt','HospitalLevel','Country','Province','Office','SpeakerLevel','CostCenter','WbsCode','SysErrorTip','MeetingGsdType','MeetingGsdTypeSub1','MeetingGsdTypeSub2','MeetingGsdTypeSub3'])
        .then(() => {
          this.handleMainSearch(this.searchMainData.quarter);
     })

    costCenterAndWbs.listLocalCostCenter({companyCode: this.userInfo.companyCode})
              .then(res => {
                this.costCenterArray = res;
              })
  }
};
</script>

<style lang="less" scoped>

  .page-contain-tab {
    margin-bottom: 70px !important;
  }
  .application-search-content-main {
    background-color: #fff;
    padding: 8px 20px;
    border-radius: 4px;
    margin-bottom: 14px;
    font-size: 16px;

    &-add {
      float: right;
    }

    &-fields {
      &-year {
        width: 80px;
        margin-right: 0px !important;
      }

      &-quarter {
        margin-left: 30px;

        label {
          cursor: pointer;
        }
      }
    }

    &-fields-quarter-lines {
      margin-left: 81px;
      display: flex;

      .line-active {
        border-bottom: 3px solid #0b41cd;
        margin-bottom: -8px;
      }

      &-line {
        border-bottom: 3px solid #0b41cd;
        width: 40px;
        border-bottom: none;
      }

      &-line-q1 {
        margin-left: 24px;
      }

      &-line-q2 {
        margin-left: 12px;
      }

      &-line-q3 {
        margin-left: 10px;
      }

      &-line-q4{
        margin-left: 12px;
      }
    }
  }

  .page-contain-main-tab {
    margin-bottom: 14px;
    display: flex;
    background-color: transparent !important;

    .main-blocks {
      display: flex;
      width: 100%;
      flex-flow: row nowrap;
      justify-content: space-between;
    }

    .main-block {
      height: 150px;
      width: 287px;
      display: inline-block;
      border: none;
      background: #fff;
      border-radius: 4px;



      &-contain {
        display: inline-block;
        width: 235px;


        &-title {
          margin-left: 24px;
          margin-top: 16px;
          height: 22px;
          line-height: 22px;
          font-size: 16px;
          color: @contentFontColor;
          width: 100%;
          .iconfont {
            float: right;
            font-size: 14px;
          }
        }

        &-application {
          margin-left: 24px;
          margin-top: 18px;
          height: 30px;
          line-height: 30px;
          font-size: 22px;
          width: 100%;

          label {
            color: rgba(0,0,0,0.85);
          }
          .iconfont {
            font-size: 28px;
          }

          .icon-yitijiao {
            color:#2D82F0;
          }

          .icon-shenpizhong {
            color:#FFB52A;
          }

          .icon-shenpitongguo {
            color:#0EC771;
          }

          .icon-shenpijujue {
            color:#FB304D;
          }
        }

        &-split-line {
          border-top: 1px solid #E8E8E8;
          width: 218px;
          margin: 20px 0 0 24px;
        }

        &-total {
          margin: 9px 0 0 24px;
          font-size: 14px;
          color: rgba(0,0,0,0.65);

          label {
            margin-left: 8px;
          color: rgba(0,0,0,0.85);
          }
        }
      }
    }
  }

  .search-content {
    display: flex;
    margin-bottom: 26px;
    .search-content-fields {
      // float:left;
      display: contents;

      &-operate {
        margin-left: auto !important;
      }

    }

    .el-form-item + .el-form-item {
      margin-left: 23px;
    }
  }

  .l-user-item {
    width: 100%;
    height: 57px;
    padding: 18px 22px;
    border-bottom: 1px solid #dfdfdf;
    display: flex;
    align-items: center;

    &-icon {
      font-size: 16px;
      padding: 2px;
    }
  }

  .toolbar {
    height: 38px;

    .application-detail-info {
      float: left;
      height: 22px;
      line-height: 22px;
      font-size: @subSubFontSize;
      color: @subSubFontColor;
    }
    .operate {
      float: right;
      height: 22px;
      line-height: 22px;

      &-export {
        font-size: 14px;

        a {
          color: @mainColor;
        }

        i {
          font-size:14px;
        }
      }
    }
  }


  .main-application-info-block {
    display: flex;
    padding-bottom: 16px;

    &-name {
      width: 50%;

      label {
        float: right;
        font-size: @contentFontSize;
        color: @contentFontColor;
      }
    }

    &-value {
      font-size: @subSubFontSize;
      color: @subSubFontColor;
    }
  }

  .bottom-info {
    display: flex;
    position: fixed;
    background-color: #fff;
    width: 100%;
    left: 0;
    height: 44px;
    box-shadow: -1px 0px 4px 0px rgba(51,51,51,0.35);
    bottom: 0;
    z-index: 5;

    &-info {
      margin-left: 120px;
      line-height: 44px;
    }

    &-operate {
      position: absolute;
      right: 120px;
      line-height: 46px;
    }
  }

.advanced-search-dialog {
  padding: 0;

  .advanced-search-dialog-close {
    font-size: @contentFontSize;
  }

  .el-form.el-form--label-right{
    margin-bottom: 5px;
    .el-row {
      padding: 28px 0 0 0;
      display: flex;

      .advanced-search-form-title {
        height: 40px;
        line-height: 40px;
        width: 90px;
        font-weight: bold;

        .iconfont {
          font-size: 14px;
        }
      }

      .el-col {
        width: 240px;

        .el-form-item__label {
          height: 24px;
          line-height: 24px;
          color: @contentFontColor;
          font-size: @contentFontSize;
        }

        .el-form-item__content {
          padding-top: 2px;

          .el-select, .el-input {
            width: 240px;
          }

          label {
            margin-left: 10px;
          }
        }
      }

      .el-col  + .el-col {
        margin-left: 123px;
      }
    }
  }

  &-close {
    margin-left: 25px;
    cursor: pointer;
  }

  &-score-model {
    display: flex;
    width: 240px;

    .el-input-number {
      width: 96px !important;
    }

    span {
      margin: auto 20px;
      width: 10px;
      border-bottom: 2px solid #666666;
    }
  }

 &-queue-model {
    display: flex;
    width: 240px;

    .el-input-number {
      width: 96px !important;
    }

    span {
      margin: auto 20px;
      width: 10px;
      border-bottom: 2px solid #666666;
    }
  }
  .l-user-item {
    width: 100%;
    height: 40px;
    padding: 0px 22px;
    display: flex;
    align-items: center;

    &-icon {
      font-size: 16px;
      padding: 2px;
      width: 20px;
    }

    &-text {
      margin-left: 5px;
      font-size: 14px;
      line-height: 20px;
      display: inline-block;
    }

    &:hover {
      color: @mainColor;
      cursor: pointer;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}

</style>

<style lang="less">
.meetingplan-application {
    .common-confirm-info {
        div + div {
                margin-top: 5px !important;
                line-height: 24px;
                padding: 0 20px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// index.vue?1c627686